import React from 'react';
import CalendarFrontDeskList from './components/CalendarFrontDeskList2';

const CalendarFrontDesk = () => (
  <React.Suspense fallback={<div>Loading...</div>}>
    <CalendarFrontDeskList />
  </React.Suspense>
);

export default CalendarFrontDesk;
